import React, { useState, Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './pricing14.css'

const Pricing14 = (props) => {
  const [isMonthly, setIsMonthly] = useState(true)
  return (
    <div
      className={`pricing14-pricing23 thq-section-padding ${props.rootClassName} `}
    >
      <div className="pricing14-max-width thq-section-max-width">
        <div className="pricing14-section-title">
          <span className="pricing14-text10 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="pricing14-text37">
                  Designing Effective Training Programs
                </span>
              </Fragment>
            )}
          </span>
          <div className="pricing14-content">
            <h2 className="pricing14-text11 thq-heading-2">
              {props.heading1 ?? (
                <Fragment>
                  <span className="pricing14-text36">What We Offer</span>
                </Fragment>
              )}
            </h2>
          </div>
        </div>
        {isMonthly && (
          <div className="pricing14-container">
            <div className="pricing14-column1 thq-card">
              <div className="pricing14-price1">
                <div className="pricing14-price2">
                  <p className="pricing14-text12 thq-body-large">
                    {props.plan1 ?? (
                      <Fragment>
                        <span className="pricing14-text41">
                          Data Solutions and Digital Transformation
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list1">
                  <div className="pricing14-list-item10">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature221 ?? (
                        <Fragment>
                          <span className="pricing14-text35">
                            Digital adoption Skills
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item11">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature22 ?? (
                        <Fragment>
                          <span className="pricing14-text46">
                            Personal development
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item12">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text42">
                            <span>Work based programs</span>
                            <br></br>
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item13">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text47">
                            New-to-role training
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item14">
                    <svg viewBox="0 0 1024 1024" className="thq-icon-small">
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text32">
                            Management training
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing14-column2 thq-card">
              <div className="pricing14-price3">
                <div className="pricing14-price4">
                  <p className="pricing14-text18 thq-body-large">
                    {props.plan2 ?? (
                      <Fragment>
                        <span className="pricing14-text50">
                          Strategy &amp; Advisory Services
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list2">
                  <div className="pricing14-list-item15">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon20 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature32 ?? (
                        <Fragment>
                          <span className="pricing14-text51">
                            Data &amp; Infrastructure Gap Assessment
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item16">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon22 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature322 ?? (
                        <Fragment>
                          <span className="pricing14-text45">
                            AI Readiness Assessment
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item17">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon24 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan1Feature321 ?? (
                        <Fragment>
                          <span className="pricing14-text31">
                            Transformation Go-to Plan
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item18">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon26 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text34">
                            Implementation Roadmaps
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item19">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon28 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan2Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text52">
                            Strategic Planning Support
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="pricing14-column3 thq-card">
              <div className="pricing14-price5">
                <div className="pricing14-price6">
                  <p className="pricing14-text24 thq-body-large">
                    {props.plan3 ?? (
                      <Fragment>
                        <span className="pricing14-text49">
                          Skills Development &amp; Training
                        </span>
                      </Fragment>
                    )}
                  </p>
                </div>
                <div className="pricing14-list3">
                  <div className="pricing14-list-item20">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon30 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature1 ?? (
                        <Fragment>
                          <span className="pricing14-text38">
                            14+ Tailored Programs
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item21">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon32 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature2 ?? (
                        <Fragment>
                          <span className="pricing14-text33">
                            Expert Facilitation
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item22">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon34 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature22 ?? (
                        <Fragment>
                          <span className="pricing14-text48">
                            Client-Centric Curriculum Development
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item23">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon36 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature3 ?? (
                        <Fragment>
                          <span className="pricing14-text40">
                            Continuous Learning Opportunities
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                  <div className="pricing14-list-item24">
                    <svg
                      viewBox="0 0 1024 1024"
                      className="pricing14-icon38 thq-icon-small"
                    >
                      <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                    </svg>
                    <span className="thq-body-small">
                      {props.plan3Feature4 ?? (
                        <Fragment>
                          <span className="pricing14-text39">
                            Workshops and Seminars
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Link to="/contact" className="pricing14-button thq-button-filled">
        <span className="pricing14-text30 thq-body-small">
          {props.plan1Action ?? (
            <Fragment>
              <span className="pricing14-text53">Connect With Us</span>
            </Fragment>
          )}
        </span>
      </Link>
    </div>
  )
}

Pricing14.defaultProps = {
  plan1Feature321: undefined,
  plan1Feature3: undefined,
  plan3Feature2: undefined,
  plan2Feature1: undefined,
  plan1Feature221: undefined,
  heading1: undefined,
  content1: undefined,
  plan3Feature1: undefined,
  plan3Feature4: undefined,
  plan3Feature3: undefined,
  plan1: undefined,
  rootClassName: '',
  plan1Feature1: undefined,
  plan1Feature322: undefined,
  plan1Feature22: undefined,
  plan1Feature2: undefined,
  plan3Feature22: undefined,
  plan3: undefined,
  plan2: undefined,
  plan1Feature32: undefined,
  plan2Feature2: undefined,
  plan1Action: undefined,
}

Pricing14.propTypes = {
  plan1Feature321: PropTypes.element,
  plan1Feature3: PropTypes.element,
  plan3Feature2: PropTypes.element,
  plan2Feature1: PropTypes.element,
  plan1Feature221: PropTypes.element,
  heading1: PropTypes.element,
  content1: PropTypes.element,
  plan3Feature1: PropTypes.element,
  plan3Feature4: PropTypes.element,
  plan3Feature3: PropTypes.element,
  plan1: PropTypes.element,
  rootClassName: PropTypes.string,
  plan1Feature1: PropTypes.element,
  plan1Feature322: PropTypes.element,
  plan1Feature22: PropTypes.element,
  plan1Feature2: PropTypes.element,
  plan3Feature22: PropTypes.element,
  plan3: PropTypes.element,
  plan2: PropTypes.element,
  plan1Feature32: PropTypes.element,
  plan2Feature2: PropTypes.element,
  plan1Action: PropTypes.element,
}

export default Pricing14
